module.exports = __webpack_public_path__ + "media/images/avatar/7-707aea5abc21daf2ac7a32447f978abe.svg";